import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';

import { EmptyTitleComponent } from './EmptyTitleComponent';

const EmptyWaitlist = () => {
  const { t } = useTranslation();

  return (
    <div className="page-empty">
      <img
        src={company.images.waitlist.empty}
        className="page-empty__image"
        alt=""
      />
      <EmptyTitleComponent className="text-center">
        {t('subscription:waitlistEmpty')}
      </EmptyTitleComponent>
    </div>
  );
};

export default EmptyWaitlist;
